import React from "react";

const NotFound = () => {
  return (
    <div>
      <img src="/images/404.jpg" alt="Not Found" />
    </div>
  );
};

export default NotFound;
